import React, { useState, useEffect, useRef, useContext, BaseSyntheticEvent, FocusEvent } from "react";
import { Form, Input, Select, InputNumber } from "antd";
const defaultValue = null
const EditableContext = React.createContext(defaultValue);

const EditType = [
    'select',
    'inputNumber',
    'input'
]

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    enterRow,
    column,
    editList,
    editType,
    prefix,
    suffix,
    checkAll,
    selectList = [],
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const [selectVal, setSelectVal] = useState(-1)
    const inputRef = useRef();
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
        if (editType == "select") {
            setSelectVal(selectList.findIndex((item) => item.value === record[dataIndex]))
        }
    }, [editing])

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const onKeyDown = async (event) => {
        let node = event.target
        let trParentNode = node.closest("tr")
        let checkRow = checkAll ? 1 : 0//这里查看表格是否为多选状态
        let findIndex = editList.findIndex((item) => item.id == record.id)
        let findInd = column.findIndex((item) => item.dataIndex == dataIndex)
        if (event.keyCode === 40 && findIndex !== editList.length - 1) {
            trParentNode.nextSibling.children[findInd + checkRow].children[0].click()
        }
        if (event.keyCode === 38 && findIndex !== 0) {
            trParentNode.previousSibling.children[findInd + checkRow].children[0].click()
        }
        if (event.keyCode === 9) {
            event.stopPropagation();
            event.preventDefault();
            let reducerArr = column.reduce((cur, pre, index) => {
                if (pre.editable) {
                    cur.push(index + checkRow)
                }
                return cur
            }, [])
            let subscript = reducerArr.indexOf(findInd + checkRow)
            if (subscript === reducerArr.length - 1) {
                trParentNode.children[reducerArr[0]].children[0].click()
            } else {
                trParentNode.children[reducerArr[subscript + 1]].children[0].click()
            }
        }
        if (event.keyCode === 13) {
            event.stopPropagation()
            const values = await form.validateFields();
            enterRow({ ...record, ...values })
        }
    }
    const save = async (e) => {
        e.stopPropagation()
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('数据保存失败', errInfo);
        }
    };
    const save1 = async (value) => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('数据保存失败', errInfo);
        }
    }
    const onFocus = (e) => {
        inputRef.current.select()
    }
    const onkeydown = (e) => {
        if (e.keyCode === 83 && selectVal !== selectList.length - 1) {
            let filterInd = selectList.filter((item, index) => index === selectVal + 1)
            let val = filterInd[0].value
            setSelectVal(selectVal + 1)
            form.setFieldsValue({ [dataIndex]: val })
        }
        if (e.keyCode === 87 && selectVal !== 0) {
            let filterInd = selectList.filter((item, index) => index === selectVal - 1)
            let val = filterInd[0].value
            setSelectVal(selectVal - 1)
            form.setFieldsValue({ [dataIndex]: val })
        }
    }
    const inputTypes = (str, record, prefix, suffix) => {
        console.log(str)
        if (editType === EditType[0]) {
            console.log(selectList)
            return <Select onKeyDown={onKeyDown} onInputKeyDown={onkeydown} ref={inputRef} onChange={save1} onBlur={save} options={selectList}></Select>
        } else {
            return <Input ref={inputRef}
                onFocus={onFocus}
                onBlur={save}
                prefix={prefix}
                suffix={suffix}
                onKeyDown={onKeyDown}
                autoComplete="off"
                style={{
                    margin: 0,
                }}
            />
        }

    }
    const proof = (editType) => {
        switch (editType) {
            case EditType[0]:
                return [{ required: true, message: `不能为空.` }]
            case EditType[1]:
                return [{ required: true, message: `不能为空.` }, { type: 'number', transform: (value) => Math.abs(Number(value)), message: `当前不是一个有效数字`, }]
            case EditType[2]:
                return []
            default:
                return []
        }
    }
    let childNode = children;
    if (editable || (record && record.editShow)) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={proof(editType)}
            >
                {inputTypes(editType, record, prefix, suffix)}
            </Form.Item>
        ) : (
                <div
                    className="editable-cell-value-wrap"
                    onClick={toggleEdit}
                >
                    {children}
                </div>
            );
    }
    return <td {...restProps}>{childNode}</td>
}
export {
    EditableRow,
    EditableCell
}  